import React from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { organizedNeeds, productName, systemFlow } from '../data/content';
import { Mark, SectionTitle } from './ui/Section';
export function ProblemSolution() {
  return <section className="bg-white px-4 py-12 md:py-16" data-id="element-197" data-mp="3mr2xsp5146pt">
      <div className="mx-auto max-w-5xl" data-id="element-198" data-mp="3hrghu7xtgcdb">
        <SectionTitle data-id="element-199" data-mp="3hsrkg4fize2u">
          What if your senior rehabilitation sessions <Mark data-id="element-200" data-mp="icl98mh1nsk4">were already organized?</Mark>
        </SectionTitle>
        <div className="mx-auto mt-4 max-w-2xl space-y-3 text-center text-sm leading-relaxed text-slate-600 md:text-base" data-id="element-201" data-mp="idwd0mahp0b8">
          <p data-id="element-202" data-mp="9j848m5ph0ho">You probably know plenty of balance exercises, gait drills, and functional rehabilitation techniques.</p>
          <p data-id="element-203" data-mp="4jlsyi9ftubi">
            But when an older adult presents with walking difficulties, reduced strength, poor postural control, or
            impaired balance, choosing the right exercises and organizing them into a complete session takes time.
          </p>
          <p data-id="element-204" data-mp="6sitnnrfo4ho">
            The <strong className="text-teal-950" data-id="element-205" data-mp="6s0q062fynzq">{productName}</strong> gives you structured professional resources to
            help select, organize, and adapt rehabilitation interventions.
          </p>
        </div>
        <p className="mt-5 text-center text-sm font-black uppercase tracking-[.2em] text-teal-700" data-id="element-206" data-mp="3u6edcbovvzfg">
          Assess. Select. Apply. Progress.
        </p>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-207" data-mp="1zfyxcax6ozw">
          <div className="flex flex-col rounded-2xl border border-teal-800/10 bg-slate-50 p-6" data-id="element-208" data-mp="3k6nninb9q8lp">
            <h3 className="text-base font-black uppercase leading-tight text-teal-950 md:text-lg" data-id="element-209" data-mp="3p7b8osctfv80">
              Turn scattered exercises into complete rehabilitation plans.
            </h3>
            <div className="mt-3 flex-1 space-y-2 text-sm leading-relaxed text-slate-600" data-id="element-210" data-mp="3f9dmeaeio8i1">
              <p data-id="element-211" data-mp="19f44qb9owypy">
                Clinical notes, training courses, saved videos, and exercise libraries can quickly become difficult to
                organize.
              </p>
              <p data-id="element-212" data-mp="2mefi3on8mhyo">
                This system brings advanced rehabilitation techniques together with clear execution instructions,
                exercise dosage, clinical modifications, and complete treatment examples.
              </p>
              <p data-id="element-213" data-mp="2ddrfdq3ao413">
                Instead of searching through different resources before each appointment, access organized material
                built around real functional rehabilitation needs.
              </p>
            </div>
            <p className="mt-5 text-xs font-black uppercase tracking-wider text-teal-700" data-id="element-214" data-mp="3568fdv9capc7">
              More structure. Clearer decisions. Better-organized sessions.
            </p>
          </div>

          <div className="flex flex-col rounded-2xl bg-teal-800 p-6" data-id="element-215" data-mp="2w9r2amhf0hdt">
            <h3 className="text-base font-black uppercase leading-tight text-white md:text-lg" data-id="element-216" data-mp="2rcqrxzdj8sgw">
              One system. <span className="text-amber-300" data-id="element-217" data-mp="3ouheyqd7pxlq">Multiple rehabilitation needs.</span>
            </h3>
            <ul className="mt-4 flex-1 space-y-2.5" data-id="element-218" data-mp="3jzl9ooiytdqo">
              {organizedNeeds.map(item => <li key={item.question} className="flex items-start gap-2 text-sm text-white/85" data-id="element-219" data-mp="3rexc0ui64bc7">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-amber-300" aria-hidden="true" data-id="element-220" data-mp="8m4cfinkcbw" />
                  <span data-id="element-221" data-mp="57pay4ea6qlz">
                    <strong className="font-bold text-white" data-id="element-222" data-mp="96y4b85esmh0">{item.question}</strong> {item.answer}
                  </span>
                </li>)}
            </ul>
            <ol className="mt-5 flex flex-wrap items-center gap-1.5" data-id="element-223" data-mp="e4gef1v5x7ql">
              {systemFlow.map((step, index) => <li key={step} className="flex items-center gap-1.5" data-id="element-224" data-mp="nwcdog8zj3we" data-mpi={index}>
                  {index > 0 && <ArrowRightIcon className="h-3.5 w-3.5 text-amber-300" aria-hidden="true" data-id="element-225" data-mp="nyghky6vw2wo" />}
                  <span className="whitespace-nowrap rounded-md bg-white px-2 py-1 text-[10px] font-black uppercase tracking-wide text-teal-950" data-id="element-226" data-mp="sx016ry092lv">
                    {step}
                  </span>
                </li>)}
            </ol>
          </div>
        </div>
      </div>
    </section>;
}